module.exports = "https://img.zhijierongxing.com/saas/img/Payment_icon2.dd47a908.png";